import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  requestDocTypesStatus,
  requestDocumentUpload,
  requestEmpStatus,
  requestGetEmpStatus,
  setResetDocumentUploadState,
  setResetEmpStatusState,
  setResetGetEmpStatus,
} from "../../Redux/EmployeeStatusState/empStatusActionCreator";
import LOCAL_KEYS, { parseLocalStorageJSON } from "../../helpers/Localstorage";
import Loader from "../../components/Loader";
import { MdDelete, MdDownload, MdEdit, MdArrowBack } from "react-icons/md";
import { Formik, Form } from "formik";
import TextInput from "../../components/TextInput";
import { statusOptions } from "../../Constants";
import CustomDropdown from "../../components/CustomDropdown";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { requestUserById } from "../../Redux/UserState/UserActionCreator";
import CustomDataTable from "../../components/CustomDataTable";
import {
  requestDownloadFileAction,
  setResetStatedownloadFile,
} from "../../Redux/FileState/uploadFileActionCreator";
import DocumentModal from "../EmployeeStatus/DocumentModal";
import { toast } from "react-toastify";
import { FaRegCalendarAlt } from "react-icons/fa";
import CustomDatePicker from "../../components/CustomDatePicker";
import MuiDatePicker from "../../components/MuiDatePicker";
import CustomToolTip from "../../components/ToolTip";
import { statusValidationSchema } from "../../components/Helpers";

const DocumentsForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const dispatch = useDispatch();
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const getEmpStatusReducer = useSelector((state) => state.GetEmpStatusReducer);
  const userByIdReducer = useSelector((state) => state.UserByIdReducer);
  const DocumentTypes = useSelector((state) => state.GetDocTypesReducer);
  const DownloadFileReducer = useSelector((state) => state.DownloadFileReducer);
  const documentUploadReducer = useSelector(
    (state) => state.DocumentUploadReducer
  );
  const empStatusReducer = useSelector((state) => state.EmpStatusReducer);
  const [docModelOpen, setDocModelOpen] = useState({
    isOpen: false,
    title: "",
  });
  const [listOfDocs, setListOfDocs] = useState([]);
  const [formValues, setFormValues] = useState({
    userId: "",
    fullName: "",
    userStatus: "",
    startDate: "",
    endDate: "",
    statusCode: "",
  });

  const documentInitialValues = {
    issueDate: "",
    expiryDate: "",
    documentType: "",
    others: "",
    file: null,
  };

  const columns = [
    // { name: "Document Name", selector: (row) => row.fileName, sortable: true },
    {
      name: "Document Type",
      selector: (row) => row.documentType,
      sortable: true,
    },
    {
      name: "Issue Date",
      selector: (row) => row.issueDate ? moment(row.issueDate).format("MM-DD-YYYY") : "NAN",
      sortable: true,
      hide: "sm"
    },
    {
      name: "Expiry Date",
      selector: (row) => row.expiryDate ? moment(row.expiryDate).format("MM-DD-YYYY") : "NAN",
      sortable: true,
      hide: "sm",
      },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-4">
          <button
            // disabled={isEditing}
            onClick={() => handleClick(id, row.fileId, "delete", row.fileName)}
            className="text-red-500 hover:text-red-700 disabled:cursor-not-allowed"
          >
            <>
              <MdDelete size={24} data-tip data-for="Delete" />
              <CustomToolTip id="Delete" title="Delete" />
            </>
          </button>
          <button
            // disabled={isEditing}
            onClick={() =>
              handleClick(id, row.fileId, "download", row.documentType)
            }
            className="text-primary hover:text-blue-700 disabled:cursor-not-allowed"
          >
            <>
              <MdDownload size={24} data-tip data-for="Download" />
              <CustomToolTip id="Download" title="Download" />
            </>
          </button>
        </div>
      ),
    },
  ];

  const handleDocumentModal = () => {
    let typeOfDocs = getEmpStatusReducer?.response?.files?.map(
      (file) => file.documentType
    );
    let result = DocumentTypes?.response?.filter(
      (value) => !typeOfDocs?.includes(value)
    );
    setListOfDocs(result);
    setDocModelOpen({ isOpen: true, title: "Add Document" });
  };

  const handleSubmit = (values) => {
    if (isEdit) {
      dispatch(
        requestEmpStatus({
          userId: id,
          userStatus: values.userStatus,
          startDate: values.startDate,
          endDate: values.endDate,
          statusCode: values.statusCode,
        })
      );
    }
    dispatch(requestGetEmpStatus(id ? id : userDetails?.id));
  };

  const retryFetch = async (effectiveId, documentType, retries = 5, delay = 500) => {
    for (let i = 0; i < retries; i++) {
      await new Promise((res) => setTimeout(res, delay));
 
      await dispatch(requestGetEmpStatus(effectiveId, true));
 
      const updatedFiles = getEmpStatusReducer?.response?.files || [];
 
      const isDocPresent = updatedFiles.some(
        (file) => file.documentType === documentType
      );
 
      if (isDocPresent) {
        handleClose();
        return true; // success
      }
    }
    return false; // failed after retries
  };

  const submitDocument = async (values) => {
    try {
      setIsRefreshing(true);
      await dispatch(
        requestDocumentUpload({
          userId: id || userDetails?.id,
          issueDate: values.issueDate
            ? moment(values.issueDate).format("YYYY-MM-DD")
            : null,
          expiryDate: values.expiryDate
            ? moment(values.expiryDate).format("YYYY-MM-DD")
            : null,
          others: values.others,
          documentType: values.documentType,
          file: values.file,
        })
      );
    } catch (error) {
      console.error('Error in document upload:', error);
      toast.error('Failed to upload document. Please try again.');
      setIsRefreshing(false);
    }
  };

  const handleClose = () => {
    setDocModelOpen({ isOpen: false, title: "" });
    setListOfDocs([]);

  };
  const handleClick = (id, fileId, action, fileName) => {
    dispatch(
      requestDownloadFileAction(id || userDetails?.id, fileId, action, fileName, "document")
    );
  };

  const transformedFiles = getEmpStatusReducer?.response?.files.map((file) => {
    const documentType = file.documentType;
    const cleanedDocumentType = documentType.startsWith("OTHER-")
      ? documentType.replace("OTHER-", "") // Remove the "OTHER-" prefix
      : documentType;

    return { 
      ...file, 
      documentType: cleanedDocumentType,
      issueDate: file.issueDate || null,
      expiryDate: file.expiryDate || null
    };
  }) || [];

  useEffect(() => {
    if (getEmpStatusReducer?.response && !getEmpStatusReducer?.loading) {
      setFormValues(getEmpStatusReducer?.response?.employeeStatus);
    }

    if (getEmpStatusReducer?.error && !getEmpStatusReducer?.loading) {
      if (userDetails?.acctType !== "USER") {
        if (!userByIdReducer?.byIdLoading && userByIdReducer?.byIdResponse) {
          setFormValues({
            ...formValues,
            fullName: `${userByIdReducer?.byIdResponse?.firstName} ${userByIdReducer?.byIdResponse?.lastName}`,
          });
        }
      } else {
        setFormValues({
          ...formValues,
          fullName: `${userDetails?.firstName} ${userDetails?.lastName}`,
        });
      }
    }
  }, [getEmpStatusReducer]);

  useEffect(() => {
    dispatch(requestGetEmpStatus(id ? id : userDetails?.id));
    dispatch(requestDocTypesStatus());
    if (userDetails?.acctType !== "USER") {
      dispatch(requestUserById(id));
    }
  }, []);

  useEffect(() => {
    if (documentUploadReducer?.response && !documentUploadReducer?.loading) {
      const effectiveId = id || userDetails?.id;
      const documentType = documentUploadReducer.response.documentType;
 
      retryFetch(effectiveId, documentType).then(() => {
        toast.success('Document uploaded successfully');
        setIsRefreshing(false);
        dispatch(setResetDocumentUploadState());
        handleClose();
      });
    }
    if (documentUploadReducer?.error && !documentUploadReducer?.loading) {
      toast.error('Failed to upload document. Please try again.');
      setIsRefreshing(false);
      dispatch(setResetDocumentUploadState());
    }
  }, [documentUploadReducer]);

  useEffect(() => {
    if (!DownloadFileReducer?.loading && DownloadFileReducer?.error) {
      toast.error("Something went wrong");
      dispatch(setResetStatedownloadFile());
    }
    if (!DownloadFileReducer?.loading && DownloadFileReducer?.response) {
      if (DownloadFileReducer?.action === "delete") {
        dispatch(requestGetEmpStatus(id));
        toast.success("file deleted successfully");
        dispatch(setResetStatedownloadFile());
      }
    }
  }, [DownloadFileReducer]);

  useEffect(() => {
    if (!empStatusReducer?.loading && empStatusReducer?.response) {
      toast.success("User status Updated Successfully");
      setIsEdit(false);
      dispatch(setResetEmpStatusState());
      if (userDetails?.acctType !== "USER" && id) {
        dispatch(requestGetEmpStatus(id));
      } else {
        dispatch(requestGetEmpStatus(userByIdReducer?.byIdresponse?.id));
      }
    }
  }, [empStatusReducer]);

  return (
    <div className="p-5 h-[85vh] overflow-y-scroll">
      <Loader
        isLoading={
          isRefreshing ||
          userByIdReducer?.byIdLoading ||
          DownloadFileReducer?.loading ||
          empStatusReducer?.loading ||
          documentUploadReducer?.loading
        }
      />

      <DocumentModal
        initialValues={documentInitialValues}
        show={docModelOpen.isOpen}
        title={"Upload Documents"}
        onClose={handleClose}
        documentsList={listOfDocs || []}
        submitForm={submitDocument}
      />

      <div className="flex justify-between items-center sm:mb-1 w-full p-2">
        <div className="flex items-center gap-2">
          {userDetails?.acctType !== "USER" && (
            <button
              type="button"
              className="text-primary hover:text-primaryDark"
              onClick={() => navigate("/manageemployee")}
            >
              <MdArrowBack size={24} />
            </button>
          )}
          <h2 className="text-xl font-normal text-primary">
            Status & Documents
          </h2>
        </div>
        <div className="flex justify-end">
          {!isEdit && userDetails?.acctType !== "USER" && (
            <button
              className="text-white bg-primary px-4 py-1 rounded-md  hover:bg-primaryDark"
              onClick={() => setIsEdit(true)}
            >
              {/* <MdEdit size={24} /> */}
              Edit
            </button>
          )}
        </div>
      </div>

      <Formik
        initialValues={{
          ...formValues,
          fullName:
            formValues?.fullName ||
            `${userByIdReducer?.byIdResponse?.firstName} ${userByIdReducer?.byIdResponse?.lastName}`,
        }}
        enableReinitialize
        validationSchema={statusValidationSchema}
        onSubmit={handleSubmit}
      >
        {({
          submitting,
          setFieldValue,
          values,
          errors,
          touched,
          handleChange,
          resetForm,
        }) => (
          <Form
            method="post"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-6 p-2 mb-2 md:gap-4"
          >
            {/* Full Name */}
            <div className="pt-1">
              <TextInput
                type="text"
                onChange={handleChange}
                value={values?.fullName}
                name="fullName"
                disabled
                classes="w-full"
                legend
                placeholder="Employee"
              />
            </div>

            {/* User Status */}
            <div>
              <CustomDropdown
                value={
                  statusOptions?.find(
                    (status) => status.value === values.userStatus
                  ) || ""
                }
                customClasses="w-full text-left"
                name="userStatus"
                handleChange={(option) =>
                  setFieldValue("userStatus", option?.value)
                }
                placeholder="Select Status"
                options={statusOptions}
                handleGetOptionValue={(option) => option.value}
                handleGetOptionName={(option) => option.label}
                isDisabled={!isEdit}
              />
              {errors.userStatus && touched.userStatus && (
                <div className="text-red-500 text-left text-sm mt-1">{errors.userStatus}</div>
              )}
            </div>

            {/* Status Code */}
            <div>
              <CustomDropdown
                value={
                  [
                    { label: "Active(A)", value: "A" },
                    { label: "Deactive(D)", value: "D" },
                    { label: "Closed(C)", value: "C" },
                  ]?.find((status) => status.value === values.statusCode) || ""
                }
                customClasses="w-full text-left"
                name="statusCode"
                handleChange={(option) =>
                  setFieldValue("statusCode", option?.value)
                }
                placeholder="Select Status Code"
                options={[
                  { label: "Active(A)", value: "A" },
                  { label: "Deactive(D)", value: "D" },
                  { label: "Closed(C)", value: "C" },
                ]}
                handleGetOptionValue={(option) => option.value}
                handleGetOptionName={(option) => option.label}
                isDisabled={!isEdit}
              />
              {errors.statusCode && touched.statusCode && (
                <div className="text-red-500 text-left text-sm mt-1">{errors.statusCode}</div>
              )}
            </div>

            {/* Start Date */}
            <div>
              <MuiDatePicker
                label="Start Date"
                value={values?.startDate ? moment(values.startDate) : null}
                onChange={(date) => {
                  if (date) {
                    setFieldValue("startDate", date.format("MM-DD-YYYY"));
                  }
                }}
                disabled={!isEdit}
                // maxDate={values?.endDate ? moment(values.endDate) : null}
                maxDate={moment()} // Disable future dates by setting max date to today
                minDate={null}
              />
              {errors.startDate && touched.startDate && (
                <div className="text-red-500 text-left text-sm mt-1">{errors.startDate}</div>
              )}
            </div>

            {/* End Date */}
            <div>
              <MuiDatePicker
                label="End Date"
                value={values?.endDate ? moment(values.endDate) : null}
                onChange={(date) => {
                  if (date) {
                    setFieldValue("endDate", date.format("MM-DD-YYYY"));
                  }
                }}
                disabled={!isEdit}
                // minDate={values?.startDate ? moment(values.startDate) : null}
                minDate={moment().startOf('day')} // Set minimum date to today to prevent past dates
                maxDate={null} // No maximum date restriction
              />
              {errors.endDate && touched.endDate && (
                <div className="text-red-500 text-left text-sm mt-1">{errors.endDate}</div>
              )}
            </div>

            {/* Buttons */}
            <div
              className={`relative ${!isEdit && "hidden"} border-0 md:border-t`}
            >
              <span className="w-full flex justify-center space-x-4 absolute -top-2 md:static">
                <button
                  type="button"
                  onClick={() => {
                    setIsEdit(false);
                    resetForm();
                  }}
                  className="bg-gray-300 text-black rounded-lg p-2 hover:bg-gray-400 w-1/2 md:w-1/3"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`btn-submit bg-primary rounded-lg p-2 hover:bg-blue-400 w-1/2 md:w-1/3 text-white ${
                    !isEdit ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={!isEdit}
                >
                  Submit
                </button>
              </span>
            </div>
          </Form>
        )}
      </Formik>
      <div className="h-px bg-gray-400 w-full hidden sm:block lg:mb-4 sm:mb-2" />
      {/* <hr className="border-t border-gray-300" /> */}

      <CustomDataTable
        columns={columns}
        pagination={false}
        // data={getEmpStatusReducer?.response?.files || []}
        data={transformedFiles}
        fixedHeaderScrollHeight={"33vh"}
      />

      {/* <div className={`col-span-full flex pt-4 justify-end }`}>
        <button
          type="button"
          onClick={handleDocumentModal}
          className={`bg-primary text-white py-2 px-4 rounded mr-2
            `}
        >
          Upload Documents
        </button>
      </div> */}
      <div className="col-span-2 flex md:justify-end justify-center w-full mb-4 mt-4 sm:mb-1 space-x-4">
        <button
          type="button"
          onClick={handleDocumentModal}
          className={`bg-primary text-white px-4 py-2 rounded hover:bg-primaryDark w-full md:w-auto ${
            !getEmpStatusReducer?.response?.employeeStatus || isRefreshing
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
          disabled={!getEmpStatusReducer?.response?.employeeStatus || isRefreshing}
        >
          {isRefreshing ? "Refreshing..." : "Upload Documents"}
        </button>
      </div>
    </div>
  );
};

export default DocumentsForm;
